// Общий бандл: грузится на каждой странице из base.html.
// Здесь только регистрации и идемпотентные побочные эффекты — никакой работы
// с DOM на уровне модуля, иначе сломается при навигации Turbo.
// Turbo Drive: переходы без перезагрузки страницы.
import "@hotwired/turbo";

import { application } from "../application.js";

// Код, переехавший из static/js. Работает и после turbo-навигации:
// внутри вместо DOMContentLoaded используется onPageReady из lib/lifecycle.
import { installDialogDismiss } from "../lib/dialog.js";
import { installToast } from "../lib/toast.js";

import "../lib/timezone.js";
import "../lib/cookie_consent.js";
import { installMetrikaTracking } from "../lib/metrika.js";
import { installTurbo } from "../lib/turbo_setup.js";

import ActivityFiltersController from "../controllers/activity_filters_controller.js";
import AddToShelfController from "../controllers/add_to_shelf_controller.js";
import CharCounterController from "../controllers/char_counter_controller.js";
import CommentReplyController from "../controllers/comment_reply_controller.js";
import FeedbackController from "../controllers/feedback_controller.js";
import FilterModalController from "../controllers/filter_modal_controller.js";
import FilterSelectController from "../controllers/filter_select_controller.js";
import FollowController from "../controllers/follow_controller.js";
import LikeController from "../controllers/like_controller.js";
import ListSearchController from "../controllers/list_search_controller.js";
import MobileMenuController from "../controllers/mobile_menu_controller.js";
import RatingController from "../controllers/rating_controller.js";
import SeriesToggleController from "../controllers/series_toggle_controller.js";
import ShareController from "../controllers/share_controller.js";
import SiteSearchController from "../controllers/site_search_controller.js";
import StartConversationController from "../controllers/start_conversation_controller.js";
import UnreadBadgeController from "../controllers/unread_badge_controller.js";

application.register("activity-filters", ActivityFiltersController);
application.register("add-to-shelf", AddToShelfController);
application.register("char-counter", CharCounterController);
application.register("comment-reply", CommentReplyController);
application.register("feedback", FeedbackController);
application.register("filter-modal", FilterModalController);
application.register("filter-select", FilterSelectController);
application.register("follow", FollowController);
application.register("like", LikeController);
application.register("list-search", ListSearchController);
application.register("mobile-menu", MobileMenuController);
application.register("rating", RatingController);
application.register("series-toggle", SeriesToggleController);
application.register("share", ShareController);
application.register("site-search", SiteSearchController);
application.register("start-conversation", StartConversationController);
application.register("unread-badge", UnreadBadgeController);

export { application };

installToast();
installDialogDismiss();
installTurbo();
installMetrikaTracking();
